
import {XdSentry}       from "@Common/libs/sentry/xd-sentry";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {BubbleNoti}     from "@Common/ui-components/bubble-noti/bubble-noti";

export const CheckExhibitProducts = ({next}) => cs(
    consumeContext("ccApis"),
    consumeContext("systemConstants"),
    ["noti", (_, next) => BubbleNoti({next})],
    ({systemConstants, noti, ccApis}) => next(async ({save, ccStateId, itemId}) => {
        /*{ Check for broken prod files
        Known causes: including emojis, Ex:🦆 }*/
        if (systemConstants.value?.["CC_NEW_FILE_CHECK"] === 'true') {
            let urlsToCheck = await save();
            for (let i=1; i<5; i++){
                let start = new Date().getTime();
                let checkedHighResProducts = await ccApis.checkImages(urlsToCheck);
                let returnedHighResProducts = checkedHighResProducts.filter( pdf => pdf.available === true);
                let end = new Date().getTime();
                if (checkedHighResProducts.length !== returnedHighResProducts.length) {
                    noti.show({message: "Saving failed, please wait and try again. If issue continues, call for support."});
                    //Don't prevent order flow until we validate what caused the false negatives.
                    //return;
                    try {
                        XdSentry.addBreadcrumb({
                            category: "custcanv",
                            message: `Item ID: ${itemId} State ID: ${ccStateId} Failed on attempt: ${i} Time taken in milliseconds: ${end-start} Connected from URL: ${window.location.href}`,
                            level: XdSentry.Severity.Error,
                            data: checkedHighResProducts
                        });
                        XdSentry.captureMessage("CustCanv template failed.", XdSentry.Severity.Error);
                    } catch (error) {
                        console.log('There was an error attempting to log chat to sentry: ' + error.toString() );
                    }
                } else {
                    try {
                        XdSentry.addBreadcrumb({
                            category: "custcanv",
                            message: [
                                `Item ID: ${itemId}`,
                                ccStateId && `State ID: ${ccStateId}`,
                                `Succeeded on attempt: ${i}`,
                                `Time taken in milliseconds: ${end-start}`,
                                `Connected from URL: ${window.location.href}`,
                            ].filter(v=>v).join(" "),
                            level: XdSentry.Severity.Info,
                            data: checkedHighResProducts
                        });
                        XdSentry.captureMessage("CustCanv template success.", XdSentry.Severity.Log);
                    } catch (error) {
                        console.log('There was an error attempting to log chat to sentry: ' + error.toString() );
                    }
                    break;
                }
            }
        }
    })
);
